import * as React from "react";
import { PropertyPolicies as SharedUiPropertyPolicies } from "@shared-ui/lodging-property-details";
import { ComponentProps } from "typings/flexFramework/FlexComponent";
import { PropertyBexApiWrapper } from "components/shared/BexApiWrapper/PropertyBexApiWrapper";
import { RefTarget } from "@shared-ui/ref-context";
import { UitkSpacing } from "uitk-react-spacing";

const WrappedPropertyPolicies = PropertyBexApiWrapper(SharedUiPropertyPolicies);

export const PropertyPolicies: React.FC<ComponentProps> = ({ context }) => (
  <UitkSpacing margin={{ block: "three" }}>
    <RefTarget name="Policies" tag="section">
      <WrappedPropertyPolicies context={context} />
    </RefTarget>
  </UitkSpacing>
);

export default PropertyPolicies;
